import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import TopicsPanel from "./TopicsPanel";
import { TopicsProvider, TopicsStoreProvider } from "./Context";
import FloatingTopics from "./FloatingTopics";
import CreateNewThread from "./CreateNewThread";
import { UserPopup } from "./components/UserDetails";

export default function TopicsWrapper({ topicsInstance }) {
	const queryClient = new QueryClient();

	return <QueryClientProvider client={queryClient}>
		<TopicsProvider topicsInstance={topicsInstance}>

			<TopicsStoreProvider storeKey={'panel'}>
				<TopicsPanel />
			</TopicsStoreProvider>

			<TopicsStoreProvider storeKey={'floating'}>
				<FloatingTopics />
			</TopicsStoreProvider>

			<CreateNewThread />
			<UserPopup />
		</TopicsProvider>
	</QueryClientProvider>;
}